import React, { useState, useEffect } from 'react';
import { GlobalStyle, Box, Goals, Bod, BeanMod, Been, Bubble} from './style';
import Axios from 'axios';
import {BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";

function Bean (){
    const [flag, setFlag] = useState(false);
    const [load, setLoad] = useState(true);
    const [dr, setDr] = useState(false);

    function clickHandler(){
        flag ? setFlag(false) : setFlag(true)
    }

    function onLoad(){
        setTimeout(() =>{
        setLoad(false)
        }, 3000)
    }
    function randem(){
      return  Math.floor(Math.random() * words.length);
    }
    
    let start = <Bubble>Hi i'm <strong>Beanie</strong> hover, or click on me for help!</Bubble>

    let words = [
    <Bubble>Make sure to save <strong>Alt-f4</strong> before you finish any work! </Bubble>,
    <Bubble>I can help with browser issuses and dirvers.</Bubble>,
    <Bubble>Hi I see you're using <strong>detect browsers if possible</strong>. </Bubble>,
    <Bubble>Good news today <strong>fatso</strong>. </Bubble>,
    <Bubble>Hello the crime rate in your city has increased <strong>30%</strong>. </Bubble>,
    <Bubble>I'm BEAN-E.</Bubble>,
    <Bubble>Tell your mom is said<strong>sup</strong>. </Bubble>,
    <Bubble>Orange soda is <strong>consent</strong>. </Bubble>,
    <Bubble>Wow, you really did a number. </Bubble>,
    <Bubble>New Phone, who dis? </Bubble>,
    <Bubble>Wow, your desk page is messy. </Bubble>,
    <Bubble>Clear your <strong>search history</strong>. </Bubble>,
    <Bubble>Find time for <strong>crime</strong>. </Bubble>,
    <Bubble>We try and solve missing people cases. </Bubble>,
    <Bubble>Bing is better than <strong>apple</strong>. </Bubble>,
    <Bubble>I never saw no <strong>bm</strong>. </Bubble>,
    <Bubble>Fight <strong>me</strong>! </Bubble>,
    <Bubble>Free moba. </Bubble>,
    <Bubble>Colin says<strong>hi</strong>. </Bubble>,
    <Bubble>Dean is best <strong>dog food</strong>. </Bubble>,
    <Bubble><strong>Furries</strong>. </Bubble>,
    <Bubble onClick={() => alert(true)}>Do you want to meet Dr.Beene?</Bubble>,

    ]
    return(
        <div>
            <BeanMod>
                {onLoad()}
            </BeanMod>
             <Been  src={ dr ? 'drbean.png': 'beanie.png' }
            onMouseEnter={(() => setFlag(true))}  onclick={(() => clickHandler)}
            onMouseLeave={(() => setFlag(false))}
            />
            {
              load ?
              start 
              :
              ''
            }
            {
              flag ? 
              words[randem()]
              :
              ''
            }
        </div>
    )
}

export default Bean;